// 交易类型 合约2  现货1
export enum TRADE_TYPE {
  SPOT = 1,
  FUTURES = 2,
  fiat = 3,
}
/**
 * 价格提醒类型 1.价格涨到 2.价格跌到 3.涨幅达到 4.跌幅达到 5.24小时涨幅 6.24小时跌幅 7.进入通道 8.离开通道
 */
export enum ALERT_TYPE {
  /**价格涨到 */
  ONE = 1,

  /** 价格跌到*/
  TWO = 2,

  /**涨幅达到 */
  THREE = 3,

  /** 跌幅达到*/
  FOUR = 4,

  /** 24小时涨幅*/
  FIVE = 5,

  /** 24小时跌幅*/
  SIX = 6,

  /**进入通道 */
  SEVEN = 7,

  /** 离开通道*/
  EIGHT = 8,
}
//1,2显示价格百分比
export const pricePercentGroup = [ALERT_TYPE.ONE, ALERT_TYPE.TWO];

//3,4,5,6显示百分比
export const percentGroup = [
  ALERT_TYPE.THREE,
  ALERT_TYPE.FOUR,
  ALERT_TYPE.FIVE,
  ALERT_TYPE.SIX,
];

//7,8显示通道数值
export const channelGroup = [ALERT_TYPE.SEVEN, ALERT_TYPE.EIGHT];

//涨跌幅组
export const upDownGroup = [
  ALERT_TYPE.THREE,
  ALERT_TYPE.FOUR,
  ALERT_TYPE.FIVE,
  ALERT_TYPE.SIX,
];

//涨幅、24小时涨幅组、涨到
export const RISE_GROUP = [ALERT_TYPE.THREE, ALERT_TYPE.FIVE, ALERT_TYPE.ONE];

//跌幅、24小时跌幅组、跌到
export const DOWN_GROUP = [ALERT_TYPE.FOUR, ALERT_TYPE.SIX, ALERT_TYPE.TWO];

//业务类型：1：现货提醒。2：合约提醒 3：fiat提醒
export enum BUSSINE_LINE_TYPE {
  SPOT = 1,
  FUTURES = 2,
  fiat = 3,
}

//创建提醒弹框操作类型
export enum OPERATION_TYPE {
  ADD = "add",
  EDIT = "edit",
}
//已读状态 0未读，1已读
export enum READ_STATUS {
  UNREAD = 0,
  READ = 1,
}
//关0   开1
export enum ALERT_OPEN {
  CLOSE = 0,
  OPEN = 1,
}

//价格提醒频率  1.每次 2.每天只提醒一次 3.只提醒一次
export enum ALERT_FREQUENCY {
  EVERY = 1,
  ONCEADAY = 2,
  ONCEONLY = 3,
}

//提醒方式（1:push 2:短信 3:邮箱 4站内信 5：pop）接口接收string类型
export enum ALERT_MODE {
  PUSH = "1",
  SMS = "2",
  EMAIL = "3",
  STATION = "4",
  POP = "5",
}

//价格类型 已和后端确认
export enum PRICE_TYPE {
  MARKET = 0, //市场价格
  MARK = 1, //标记价格
  INDEX_PRICE = 2, //指数价格
}

// 价格提醒开关（合约、现货、等等）
export enum ALERT_SWITCH {
  OPEN = 0,
  CLOSE = 1,
}
